import CustomMessage from 'components/common/CustomMessage';
import { Card } from 'react-bootstrap';
import { FaHouseUser } from 'react-icons/fa';

const NoRealEstateCard = () => {
  return (
    <Card className="bg-white">
      <Card.Body>
        <CustomMessage
          message="El matriculado no ha creado su inmobiliaria todavía, por lo que no hay información disponible para mostrar."
          title="Información no disponible."
          ReactIcon={FaHouseUser}
          titleStyles={{ fontSize: 20 }}
        />
      </Card.Body>
    </Card>
  );
};

export default NoRealEstateCard;
